import { socket } from ".";



export const newConversationListener = (dispatch)=>{
    socket.connect()
    socket.on("broadcast-message",(data)=>{
        console.log('read-message-reponse est emise avec le data', data)

       dispatch("conversations/list/socketConversation",data,{root:true})
    })

    socket.on("read-message-response",(data)=>{
        console.log('read-message-reponse est emise avec le data', data)
        dispatch("conversations/list/readConversation",data,{root:true})
    })


}

export const readMessage = (data)=>{
    socket.emit("read-message",data)
}
export default newConversationListener

